import TributacoesService from "@/services/TributacoesService";

export const tributacoes = {
  namespaced: true,
  state: {
    tributacoes: {},
  },
  actions: {
    getTributacoes({ commit }, payload) {
      return TributacoesService.GetTributacoes(payload).then(
        (tributacoes) => {
          return Promise.resolve(tributacoes);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postTributacoes({ commit }, payload) {
      return TributacoesService.PostTributacoes(payload).then(
        (tributacoes) => {
          return Promise.resolve(tributacoes);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putTributacoes({ commit }, payload) {
      return TributacoesService.PutTributacoes(payload).then(
        (tributacoes) => {
          return Promise.resolve(tributacoes);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteTributacoes({ commit }, payload) {
      return TributacoesService.DeleteTributacoes(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getTributacoesOData({ commit }, payload) {
      return TributacoesService.GetTributacoesOData(payload).then(
        (tributacoes) => {
          return Promise.resolve(tributacoes);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default tributacoes;
